import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/** Constrains Recharts ResponsiveContainer so it cannot widen the page on narrow viewports. */
export function ResponsiveChartBox({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  );
}
